import { createTab, mergeTabObjects } from "util/tabUtils";

export type AdminProjectDetailsTabKeyT =
  | "dashboard"
  | "summary"
  | "site-info"
  | "workflow"
  | "proposals"
  | "contracts"
  | "events"
  | "assets"
  | "milestones"
  | "commission"
  | "tickets"
  | "activity-log";

const additionalPostSalesTabs = {
  dashboard: createTab("dashboard", "Dashboard", { conditionalRenderSelector: "getDashboardTabVisible" }),
} as const;

const commonTabs = {
  summary: createTab("summary", "Summary"),
  siteInfo: createTab("site-info", "Site Info"),
  workflow: createTab("workflow", "Workflow"),
  proposals: createTab("proposals", "Proposals"),
  contracts: createTab("contracts", "Contracts", { conditionalRenderSelector: "getContractTabVisible" }),
  events: createTab("events", "Events"),
  assets: createTab("assets", "Assets"),
  milestones: createTab("milestones", "Milestones"),
  commission: createTab("commission", "Commission"),
  tickets: createTab("tickets", "Tickets"),
  activityLog: createTab("activity-log", "Activity Log", {
    conditionalRenderSelector: "selectActivityLogTabVisible",
    breadcrumbLabel: "Project Activities",
  }),
} as const;

export { commonTabs, additionalPostSalesTabs };

export default mergeTabObjects([additionalPostSalesTabs, commonTabs]);
